'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseUtils = require('@wix/photography-client-lib/dist/src/utils/baseUtils.js');

var _itemActions = require('@wix/photography-client-lib/dist/src/item/itemActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenShareButtons = function (_React$Component) {
  (0, _inherits3.default)(FullscreenShareButtons, _React$Component);

  function FullscreenShareButtons(props) {
    (0, _classCallCheck3.default)(this, FullscreenShareButtons);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenShareButtons.__proto__ || (0, _getPrototypeOf2.default)(FullscreenShareButtons)).call(this, props));

    _this.buttons = [];
    return _this;
  }

  (0, _createClass3.default)(FullscreenShareButtons, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      try {
        var focusedButton = this.props.focus;
        if (focusedButton > 0) {
          // this.buttonsContainer.focus();
          this.buttons[focusedButton - 1].focus();
        }
      } catch (e) {
        console.warn('Cannot focus on share icon', this.props.focus, e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var shareArr = ['facebook', 'twitter', 'pinterest', 'tumblr'];
      if (!_baseUtils.baseUtils.isiOS()) shareArr.push('email');
      if (this.props.item.type === 'text') {
        shareArr.splice(2, 1);
      }

      var buttons = shareArr.map(function (network, idx) {
        return _react2.default.createElement('button', {
          className: 'fullscreen-social-' + network + ' progallery-svg-font-icons-' + network,
          ref: function ref(button) {
            return _this2.buttons[idx] = button;
          },
          onClick: function onClick() {
            return _itemActions.itemActions.share(network, _this2.props.item, 'fullscreen');
          },
          key: network + '-share-icon',
          'data-hook': network + '-share-hook',
          title: 'Share on ' + network,
          'aria-label': 'Share on ' + network + ', ' + idx + ' of 5',
          'aria-live': 'assertive',
          role: 'button',
          tabIndex: -1
        });
      });

      return _react2.default.createElement(
        'div',
        { className: 'fullscreen-social-items-container',
          'aria-live': 'assertive',
          ref: function ref(ele) {
            return _this2.buttonsContainer = ele;
          },
          tabIndex: -1 },
        buttons
      );
    }
  }]);
  return FullscreenShareButtons;
}(_react2.default.Component);

exports.default = FullscreenShareButtons;